import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { DatagridService, NotificationService, PagedResultGeneric } from 'src/app/shared';
import { TranslationService } from 'src/app/shared/translation/translation.service';
import { LazySelectableTableComponent } from 'src/app/shared/primeng/abstract-classes/lazy-selectable-table.component';
import { ConfirmationService, MenuItem } from 'primeng/api';
import { EventListHtDto } from '../../shared/event-list-ht.dto';
import { EventSubmissionSearch } from '../../shared/event-submission-search.model';
import { EventSubmissionService } from '../../shared/event-submission.service';
import { NavigationService } from 'src/app/shared/navigation/navigation.service';

@Component({
  selector: 'wl-submission-list',
  templateUrl: './submission-list.component.html',
  styleUrls: ['./submission-list.component.less'],
    standalone: false
})
export class SubmissionListComponent extends LazySelectableTableComponent<EventSubmissionSearch, EventListHtDto> implements OnInit {
  @Output() reviewSubmission = new EventEmitter<EventListHtDto>();
  @Output() approveSubmission = new EventEmitter<EventListHtDto>();
  @Output() deleteSubmission = new EventEmitter<EventListHtDto>();

  rowMenuItems = new Map<number, MenuItem[]>();
  exporting: boolean = false;
  constructor(
    dataGridService: DatagridService,
    private _translationService: TranslationService,
    private _eventSubmissionService: EventSubmissionService,
    private _navigationService: NavigationService,
    private _notificationService: NotificationService
  ) {
    super('EventID', dataGridService);
    this.searchParams = new EventSubmissionSearch();
    this.searchParams.MinimalData = true;
  }

  ngOnInit(): void {}

  fetchResults(): Promise<PagedResultGeneric<EventListHtDto>> {
    return this._eventSubmissionService.getEventSubmissions(this.searchParams, true);
  }

  pageSizeChanged() {
    this.searchParams.PageNumber = 1;
    this.search();
  }

  actionItemsForEventSubmission(eventSubmission: EventListHtDto): MenuItem[] {
    if (!this.rowMenuItems.has(eventSubmission.EventID)) {
      this.rowMenuItems.set(eventSubmission.EventID, [
        {
          label: this._translationService.getInstantTitlecase('events.submissions.submission-list.review'),
          command: () => this.review(eventSubmission),
        },
        {
          label: this._translationService.getInstantTitlecase('events.submissions.submission-list.approve'),
          command: () => this.approve(eventSubmission),
        },
        {
          label: this._translationService.getInstantTitlecase('events.submissions.submission-list.reject'),
          command: () => this.reject(eventSubmission),
        },
        {
          label: this._translationService.getInstantTitlecase('events.submissions.submission-list.delete'),
          command: () => this.delete(eventSubmission),
        },
      ]);
    }
    return this.rowMenuItems.get(eventSubmission.EventID);
  }

  review(eventSubmission: EventListHtDto) {
    this.reviewSubmission.emit(eventSubmission);
  }

  approve(eventSubmission: EventListHtDto) {
    this._eventSubmissionService.approveEventSubmission(eventSubmission.EventID).then(() => {
      this.search();
    });
  }

  reject(eventSubmission: EventListHtDto) {
    this._eventSubmissionService.rejectEventSubmission(eventSubmission.EventID).then(() => {
      this.search();
    });
  }

  delete(eventSubmission: EventListHtDto) {
    this._eventSubmissionService.deleteEventSubmission(eventSubmission.EventID).then(() => {
      this.search();
    });
  }

  exportEventSubmissions() {
    if (this.exporting) {
      return;
    }
    this.exporting = true;
    this._eventSubmissionService
      .searchExportToCsv(this.searchParams)
      .then((csvUrl) => {
        this._navigationService.popupSafeNavigate(csvUrl);
      })
      .catch((err) => {
        this._notificationService.httpError(err);
      })
      .finally(() => {
        this.exporting = false;
      });
  }
}
